import React, { useState } from 'react';
import { Button, Popover, RadioButton } from 'selfly-ui-react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import zipcelx from 'zipcelx';
import DownloadFileButton from '../../shared/downloadFileButton';

const DiscountAnalyticsExport = ({ t, generateExcelObject, generateCSVBlob }) => {
    const OPTIONS_BASE = ['products', 'locations', 'cabinets'];
    const OPTIONS = OPTIONS_BASE.slice(0, 3);

    const [selectedOption, setSelectedOption] = useState(OPTIONS[0]);

    return (
        <Popover
            component={
                <Button icon="file_download" type="secondary">
                    {t('reports:export')}
                </Button>
            }
            isFlipping
            position="bottom"
        >
            <Row>
                <Col>
                    <div className="radio-group">
                        <label className="radio-group__label">{t('groupBy')}</label>
                        {OPTIONS.map(option => {
                            return (
                                <div className="radio-group__options" key={option}>
                                    <Row>
                                        <Col>
                                            <RadioButton
                                                id={option}
                                                key={option}
                                                label={t(option)}
                                                name={'data-grouping'}
                                                checked={option === selectedOption}
                                                onChange={() => setSelectedOption(option)}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button
                        onClick={() => {
                            zipcelx({
                                ...generateExcelObject(selectedOption),
                                filename: `Discount_history_by_${selectedOption}_${moment().format('YYYY-MM-DD')}`,
                            });
                        }}
                    >
                        Excel
                    </Button>
                </Col>
                <Col>
                    <DownloadFileButton
                        label="CSV"
                        className="export-csv se-btn se-btn--md se-btn--primary"
                        filename={`Discount_history_by_${selectedOption}_${moment().format('YYYY-MM-DD')}.csv`}
                        getBlob={() => generateCSVBlob(selectedOption)}
                    />
                </Col>
            </Row>
        </Popover>
    );
};

export default DiscountAnalyticsExport;
